import React, { Component } from 'react';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DownloadIcon from '@material-ui/icons/VerticalAlignBottom';

import Styled from './styles';
import { validateCompanyId } from '../../utils/validate';

import api from '../../lib/api';

class ExperimentsList extends Component {
  state = {
    companyId: '',
    invoiceId: '',
    paymentReceiptId: '',
    paymentPlan: null,
    paymentMode: 'CASH',
    submitting: false,
    submitSuccess: false,
    submitFail: false,
    disableFields: true,
    domain: '',
    disableDomainField: true,
    domainExtension: '',
    domainError: false,
    companyIdError: false,
    logoSelected: null,
    companyLogoExist: false,
    datePicked: null,
    currentValue: '',
    //
    mandatoryLogin: false,
    disableMandatoryLogin: true,
    disableSaveChanges: true,
    isPaymentsShown: false,
    disablePaymentsShown: true,
    isPrivacyModuleActive: false,
    disablePrivacyModuleActive: true,
    resellerGroupCreation: false,
    disableResellerGroupCreation: true,
    grtVendor: false,
    disableGrtVendor: true
  };

  onCompanyIdChange = event => {
    event.preventDefault();
    this.setState({ companyId: event.target.value });
  };

  onMandatoryLoginChange = () => {
    this.setState({
      mandatoryLogin: !this.state.mandatoryLogin,
      disableSaveChanges: false
    });
  };

  onPaymentsShownChange = () => {
    this.setState({
      isPaymentsShown: !this.state.isPaymentsShown,
      disableSaveChanges: false
    });
  };

  onPrivacyModuleChange = () => {
    this.setState({
      isPrivacyModuleActive: !this.state.isPrivacyModuleActive,
      disableSaveChanges: false
    });
  };

  onResellerGroupCreationChange = () => {
    this.setState({
      resellerGroupCreation: !this.state.resellerGroupCreation,
      disableSaveChanges: false
    });
  };

  onGrtVendorChange = () => {
    this.setState({
      grtVendor: !this.state.grtVendor,
      disableSaveChanges: false
    });
  };

  onSaveChanges = async () => {
    const {
      companyId,
      mandatoryLogin,
      isPaymentsShown,
      isPrivacyModuleActive,
      resellerGroupCreation,
      grtVendor
    } = this.state;
    await Promise.all([
      api.setMandatoryLogin(companyId, mandatoryLogin),
      api.setPaymentGatewayShown(companyId, isPaymentsShown),
      api.setPrivacyModuleActive(companyId, isPrivacyModuleActive),
      api.setResellerGroupCreation(companyId, resellerGroupCreation),
      api.setGrtVendor(companyId, grtVendor)
    ]);
    this.setState({ disableSaveChanges: true });
  };

  onDownload = async () => {
    const { companyId } = this.state;

    if (companyId && validateCompanyId(companyId)) {
      const {
        isMandatoryLogin,
        showPaymentGateway,
        enablePrivacyModule,
        resellerGroupCreation,
        grtVendor
      } = await api.getExperimentsData(companyId);

      this.setState({
        mandatoryLogin: isMandatoryLogin,
        disableMandatoryLogin: false,
        disableSaveChanges: false,
        isPaymentsShown: showPaymentGateway,
        disablePaymentsShown: false,
        isPrivacyModuleActive: enablePrivacyModule,
        disablePrivacyModuleActive: false,
        resellerGroupCreation: resellerGroupCreation,
        disableResellerGroupCreation: false,
        grtVendor,
        disableGrtVendor: false
      });
    } else {
      console.log(
        'Bad company id: either empty or contains special characters not supported by firebase'
      );
      this.setState({
        companyIdError: true,
        mandatoryLogin: false,
        disableMandatoryLogin: true,
        disableSaveChanges: true
      });
    }
  };

  render() {
    const {
      companyId,
      companyIdError,
      mandatoryLogin,
      disableMandatoryLogin,
      disableSaveChanges,
      isPaymentsShown,
      isPrivacyModuleActive,
      disablePaymentsShown,
      disablePrivacyModuleActive,
      resellerGroupCreation,
      disableResellerGroupCreation,
      grtVendor,
      disableGrtVendor
    } = this.state;

    return (
      <Styled.Container>
        <Styled.Header>
          <Styled.CompanyInputContainer>
            <TextField
              error={companyIdError}
              required
              fullWidth
              label="Company ID"
              margin="normal"
              type="text"
              value={companyId}
              onChange={this.onCompanyIdChange}
            />
          </Styled.CompanyInputContainer>

          <Styled.DownloadButtonContainer>
            <Button
              variant="flat"
              size="small"
              color="primary"
              onClick={this.onDownload} //check if the company id is empty or not
            >
              Get existing data
              <DownloadIcon nativeColor="black" />
            </Button>
          </Styled.DownloadButtonContainer>
        </Styled.Header>

        <Styled.Row>
          <Styled.Left>
            <FormControlLabel
              label="Mandatory login"
              control={
                <Switch
                  checked={mandatoryLogin}
                  onChange={this.onMandatoryLoginChange}
                  disabled={disableMandatoryLogin}
                />
              }
            />
          </Styled.Left>
        </Styled.Row>

        <Styled.Row>
          <Styled.Left>
            <FormControlLabel
              label="Enable Payments"
              control={
                <Switch
                  checked={isPaymentsShown}
                  onChange={this.onPaymentsShownChange}
                  disabled={disablePaymentsShown}
                />
              }
            />
          </Styled.Left>
        </Styled.Row>

        <Styled.Row>
          <Styled.Left>
            <FormControlLabel
              label="Privacy module"
              control={
                <Switch
                  checked={isPrivacyModuleActive}
                  onChange={this.onPrivacyModuleChange}
                  disabled={disablePrivacyModuleActive}
                />
              }
            />
          </Styled.Left>
        </Styled.Row>

        <Styled.Row>
          <Styled.Left>
            <FormControlLabel
              label="Reseller group creation"
              control={
                <Switch
                  checked={resellerGroupCreation}
                  onChange={this.onResellerGroupCreationChange}
                  disabled={disableResellerGroupCreation}
                />
              }
            />
          </Styled.Left>
        </Styled.Row>

        <Styled.Row>
          <Styled.Left>
            <FormControlLabel
              label="Grt vendor"
              control={
                <Switch
                  checked={grtVendor}
                  onChange={this.onGrtVendorChange}
                  disabled={disableGrtVendor}
                />
              }
            />
          </Styled.Left>
        </Styled.Row>

        <Styled.ButtonContainer>
          <Button
            fullWidth
            variant="raised"
            color="primary"
            disabled={disableSaveChanges}
            onClick={this.onSaveChanges}
          >
            Save changes
          </Button>
        </Styled.ButtonContainer>

        {/* <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          open={!!submitSuccess || !!submitFail}
          autoHideDuration={6000}
          onClose={this.onSnackbarClose}
          message={this.renderSnackbarMessage()}
          action={[
            <IconButton key={0} onClick={this.onSnackbarClose}>
              <CloseIcon nativeColor="#fff" />
            </IconButton>
          ]}
        /> */}
      </Styled.Container>
    );
  }
}

export default ExperimentsList;



// WEBPACK FOOTER //
// ./src/pages/ExperimentsList/index.js